import request from './request';

// 获取设备检测列表
export function getDevicesForDetection() {
  return request({
    url: '/api/devices/detection',
    method: 'get'
  });
}

// 导入设备数据
export function importDevicesData(formData) {
  return request({
    url: '/api/devices/importDevices',
    method: 'post',
    data: formData
  });
}

// 下载模板
export function downloadDeviceTemplate() {
  return request({
    url: '/api/devices/template',
    method: 'get',
    responseType: 'blob'
  });
}

// 获取导入设备列表
export function getImportedDevices(params) {
  return request({
    url: '/api/devices/import',
    method: 'get',
    params
  });
}

// 获取设备管理列表
export function getDevicesForManagement(params) {
  return request({
    url: '/api/devices/management',
    method: 'get',
    params
  });
}

// 导出设备模板
export function exportDeviceTemplate() {
  return request({
    url: '/api/devices/template',
    method: 'get',
    responseType: 'blob'
  });
}

// 获取设备类型列表
export function getDeviceTypes() {
  return request({
    url: '/api/device-types',
    method: 'get'
  });
}

// 删除设备类型
export function deleteDeviceType(id) {
  return request({
    url: `/api/device-types/${id}`,
    method: 'delete'
  });
}

// 添加设备类型
export function addDeviceType(data) {
  return request({
    url: `/api/device-types`,
    method: 'post',
    data
  });
}

// 更新设备类型
export function updateDeviceType(data) {
  return request({
    url: `/api/device-types/${data.id}`,
    method: 'put',
    data
  });
}

// 根据MAD查询设备
export function getDeviceByMad(mad) {
  return request({
    url: `/api/devices/${mad}`,
    method: 'get'
  });
}

// 重置设备设置
export function resetDeviceSettings(mad) {
  return request({
    url: `/api/devices/${mad}/reset`,
    method: 'post'
  });
}

// 清除设备密码
export function clearDevicePassword(mad) {
  return request({
    url: `/api/devices/${mad}/clear-password`,
    method: 'post'
  });
}

// 解除设备绑定
export function unbindDevice(mad) {
  return request({
    url: `/api/devices/${mad}/unbind`,
    method: 'post'
  });
}

// 解除设备分享
export function unshareDevice(mad, userId) {
  return request({
    url: `/api/devices/${mad}/unshare/${userId}`,
    method: 'post'
  });
}

// 禁用设备
export function disableDevice(mad) {
  return request({
    url: `/api/devices/${mad}/disable`,
    method: 'post'
  });
}

// 启用设备
export function enableDevice(mad) {
  return request({
    url: `/api/devices/${mad}/enable`,
    method: 'post'
  });
}

// 删除设备
export function deleteDevice(mad) {
  return request({
    url: `/api/devices/${mad}`,
    method: 'delete'
  });
}